export default function unfoldLine(lines, i) {
  let line = lines[i];
  if (line && line.length >= 74 && lines.length > i + 1) {
    for (let j = i + 1; j < lines.length; j++) {
      if (/^[ \t]+.*/.test(lines[j])) {
        line += lines[j].substr(1); // get rid of first whitespace character
      } else {
        break;
      }
    }
  }
  return line;
}
